import { createSingleton } from '@luna/utils';

import type { UseQueryOptions } from './createQueryTypes';
import type { GetReturned, PayloadCreatorBaseType } from '../utils/internalTypings';

export type DefaultQueryOptions = Partial<
    Pick<UseQueryOptions<GetReturned<PayloadCreatorBaseType>>, 'keepPreviousData' | 'throwOnError'>
>;

export const { get: getCreateQueryDefaultOptions, set: initCreateQueryDefaultOptions } =
    createSingleton<DefaultQueryOptions>();
